import { Search } from "lucide-react";
import { useEffect, useState } from "react";

const SearchInput = ({
  setSearchText,
  searchText,
  kompakt = false,
}: {
  setSearchText: (value: string) => void;
  searchText: string;
  /** Flachere Fassung fuer Verwaltungslisten. Ohne das Kennzeichen bleibt alles wie bisher. */
  kompakt?: boolean;
}) => {
  const [gotAnInput, setGotAnInput] = useState(false);
  const [inputText, setInputText] = useState(searchText || "");
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    if (inputText.length <= 2) {
      if (inputText.length === 0) {
        setSearchText("");
        setShowText(false);
      } else {
        const timer = setTimeout(() => {
          setShowText(true);
        }, 500);
        return () => clearTimeout(timer);
      }
      return;
    }
    const timer = setTimeout(() => {
      setSearchText(inputText);
    }, 500);

    setShowText(false);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gotAnInput, setSearchText]);

  return (
    <div className="">
      <div
        className={
          kompakt
            ? "flex h-[34px] items-center gap-2 rounded-lg border border-gray-200 bg-white px-2.5 text-sm text-[#888]"
            : "flex gap-3 bg-white items-center rounded-2xl px-3 py-2 shadow-sm text-[#888] text-sm"
        }
      >
        <Search size={kompakt ? 16 : 24} />
        <input
          placeholder="Suchen..."
          className={`border-none outline-none w-full focus:ring-0 ${kompakt ? "h-full min-w-[120px] bg-transparent p-0 text-sm" : "min-w-[150px]"}`}
          onChange={(e) => {
            setGotAnInput((prev) => !prev);
            setInputText(e.target.value);
          }}
          value={inputText}
        />
      </div>
      {showText && <p className="text-sm absolute text-red-500">Gib mindestens 3 Zeichen ein</p>}
    </div>
  );
};

export default SearchInput;
